import { ChainJobRequest, GetChainJobRequest } from "./chainJob.shemas";
import { putCreateChainJob, retrieveChainJob } from "./chainJob.datasource";

export async function createChainJob(body: ChainJobRequest) {
    try {
        const response = (await putCreateChainJob(body)).data;

        return response;
    } catch (error) {
        throw error;
    }
}

export async function getChainJob(params: GetChainJobRequest) {
    try {
        const response = (await retrieveChainJob(params)).data;

        return response;
    } catch (error) {
        throw error;
    }
}